import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { ExactFailuresQueryKeys } from "modules/ExactMonitoring/queryKeys";
import { ApiInstance } from "utils/Api";

type RetryFailedInvoicePayload = {
  exact_failed_invoice_id: number;
  dealer_id?: number;
  dealer_location_id?: number;
};

export const useRetryFailedInvoiceMutation = () =>
  useTypedMutation<RetryFailedInvoicePayload, void>({
    mutationFn: async payload => (await ApiInstance.post("/invoices/failed/retry", payload, ENV.exactBaseURL)).data,
    onSuccess: payload => {
      const invoicedDealersAndLocations = typedQueryClient.getQueryData(ExactFailuresQueryKeys.invoicedDealersAndLocations);
      if (!invoicedDealersAndLocations) return;

      if (payload.dealer_id) {
        const dealerIdx = invoicedDealersAndLocations.dealers.findIndex(d => d.id === payload.dealer_id);
        if (dealerIdx === -1) return;

        const dealer = invoicedDealersAndLocations.dealers[dealerIdx];
        if (!dealer.exact_failed_invoices?.length) return;

        const failedInvoiceIdx = dealer.exact_failed_invoices.findIndex(inv => inv.id === payload.exact_failed_invoice_id);
        if (failedInvoiceIdx === -1) return;

        const updatedExactInvoices = dealer.exact_failed_invoices.toSpliced(failedInvoiceIdx, 1);

        typedQueryClient.setQueryData(ExactFailuresQueryKeys.invoicedDealersAndLocations, {
          ...invoicedDealersAndLocations,
          dealers: updatedExactInvoices.length
            ? invoicedDealersAndLocations.dealers.with(dealerIdx, { ...dealer, exact_failed_invoices: updatedExactInvoices })
            : invoicedDealersAndLocations.dealers.toSpliced(dealerIdx, 1)
        });
      }

      if (payload.dealer_location_id) {
        const locationIdx = invoicedDealersAndLocations.dealer_locations.findIndex(d => d.id === payload.dealer_location_id);
        if (locationIdx === -1) return;

        const location = invoicedDealersAndLocations.dealer_locations[locationIdx];
        if (!location.exact_failed_invoices?.length) return;

        const failedInvoiceIdx = location.exact_failed_invoices.findIndex(inv => inv.id === payload.exact_failed_invoice_id);
        if (failedInvoiceIdx === -1) return;

        const updatedExactInvoices = location.exact_failed_invoices.toSpliced(failedInvoiceIdx, 1);

        typedQueryClient.setQueryData(ExactFailuresQueryKeys.invoicedDealersAndLocations, {
          ...invoicedDealersAndLocations,
          dealer_locations: updatedExactInvoices.length
            ? invoicedDealersAndLocations.dealer_locations.with(locationIdx, { ...location, exact_failed_invoices: updatedExactInvoices })
            : invoicedDealersAndLocations.dealer_locations.toSpliced(locationIdx, 1)
        });
      }
    }
  });
